module.exports = __webpack_public_path__ + "static/media/overview3_0.1d1c2da3.png";